export enum WatchlistErrorCode {
	NO_TAGGED_FUNDS_ERROR = 'NO_TAGGED_FUNDS_ERROR'
}
